module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUBAMAAAByuXB5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURUdwTJiYmJmZmZiYmJeXl5mZmZmZmZqamp+fn5mZmZmZmRA57c0AAAAKdFJOUwBF07ZggPAwEKCrmagDAAAAc0lEQVQI11XOOw5AUBCF4SMIUbmtUoVKpVBJdCrrUFmCWIbK40ZiVunOmMZffckUcwBXDs2j9EMw0d2JBiKyjHhyuhc+EsfnUDT+5IvqnxLR7pSJDqdN9AARfc1YVQUq1YlWdSEypqTTmJnX9I3VzWHOX19bYkEQ4T703wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tonzhi.png
// module id = /yqY
// module chunks = 98